import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['email', 'button']

  send (event) {
    event.preventDefault()

    const Flash = this.application.getControllerForElementAndIdentifier(
      document.getElementById('flash'), 'flash'
    )

    const email = this.emailTarget.value.trim()
    const subjectField = document.getElementById('subject')
    const bodyField = document.getElementById('body')
    const subject = subjectField ? subjectField.value.trim() : ''
    const body = bodyField ? bodyField.value.trim() : ''

    if (!email) {
      Flash.openMessage('Inserisci un indirizzo email per il test', 'orange')
      return
    }

    if (!subject || !body) {
      Flash.openMessage('Inserisci oggetto e contenuto prima di inviare la prova', 'orange')
      return
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    this.buttonTarget.setAttribute('disabled', '')
    this.buttonTarget.classList.add('is-loading')

    fetch(this.data.get('url'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({ email: email, subject: subject, body: body })
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.result) {
          Flash.openMessage((data.payload && data.payload.message) || 'Mail di prova inviata', 'green')
        } else {
          const error = (data.errors && data.errors[0]) ? data.errors[0].message : "Errore durante l'invio"
          Flash.openMessage(error, 'orange')
        }
        this.resetButton()
      })
      .catch(() => {
        Flash.openMessage("Errore durante l'invio della mail di prova", 'orange')
        this.resetButton()
      })
  }

  resetButton () {
    this.buttonTarget.removeAttribute('disabled')
    this.buttonTarget.classList.remove('is-loading')
  }
}
